// src/utils/utils.js
import axios from "axios";

export const getData = async (
  url,
  setData,
  setError,
  processData,
  setFilteredData
) => {
  try {
    const response = await axios.get(url);
    const processedData = processData
      ? processData(response.data.data)
      : response.data.data;
    setData(processedData);
    setFilteredData(processedData);
  } catch (error) {
    setError(error);
  }
};

export const fetchData = async (
  url,
  setData,
  setError,
  setFilteredData,
  page = 1,
  search = "",
  cityFilter,
  showLoader,
  hideLoader,
  setTotalPages
) => {
  try {
    showLoader();
    const response = await axios.get(url, {
      params: {
        page: page,
        search: search,
        city: cityFilter,
      },
    });

    const { data, totalPages } = response.data;
    setData(data);
    setFilteredData(data);
    setTotalPages(totalPages); // Assuming the total pages are included in the response
  } catch (error) {
    setError(error);
  } finally {
    hideLoader();
  }
};

export const fetchProductData = async (
  url,
  setData,
  setError,
  setFilteredData,
  page = 1,
  search = "",
  showLoader,
  hideLoader
) => {
  try {
    showLoader();
    const response = await axios.get(url, {
      params: {
        page: page,
        search: search,
      },
    });

    const { data } = response.data;
    setData(data);
    setFilteredData(data);
  } catch (error) {
    setError(error);
  } finally {
    hideLoader();
  }
};

export const deleteData = async (url, id, setError) => {
  try {
    await axios.delete(`${url}/${id}`);
  } catch (error) {
    setError(error);
  }
};

export const handlePageChange = (setCurrentPage) => (page) => {
  setCurrentPage(page);
};

export const getCurrentData = (data, currentPage, itemsPerPage) => {
  return data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
};
